const store = {
    namespaced: true,
    state() {
        return {
            next: null,
            previous: null,
            totalCount: 0,
            pageSize: 0,
            pages: 0,
            currentPageCount: 0,
            page: 1,
            allNews: [],
            statuses: [],
            isNewsLoading: false,

            // ==== динамические списки по статусам ====
            newsByStatus: [],
            isFiltersVisible: false,
        };
    },
    getters: {
        getAllNews: state => state.allNews,
        getStatuses: state => state.statuses,
        getNewsByStatus: state => state.newsByStatus,
        getIsNewsLoading: state => state.isNewsLoading,
        getIsFiltersVisible: state => state.isFiltersVisible,
        getPage: state => state.page,
        getTotalCount: state => state.totalCount,
        getTotalPagesCount: state => state.pages,
        // page: 'products/getPage',
        // totalPageCount: 'products/getTotalPagesCount',
        // totalCount: 'products/getTotalCount',
    },
    mutations: {
        // записать весь payload в state
        SET_PAYLOAD(state, payload) {
            state.next = payload.next;
            state.previous = payload.previous;
            state.totalCount = payload.totalCount;
            state.pageSize = payload.page_size;
            state.pages = payload.pages;
            state.currentPageCount = payload.current_page_count;

            state.allNews = payload.data;
            state.statuses = payload.statuses;
        },
        SET_PAGE(state, payload) {
            state.page = payload;
        },
        // собрать newsByStatus по статусам
        BUILD_NEWS_BY_STATUS(state) {
            if (!Array.isArray(state.statuses) || state.statuses.length === 0) {
                state.newsByStatus = [
                    {
                        news: state.allNews,
                    },
                ];
                return;
            }
            state.newsByStatus = state.statuses.map(status => {
                const filtered = state.allNews.filter(item => item.custom_status?.id === status.id);

                return {
                    name: status?.name,
                    slug: status?.status,
                    news: filtered,
                };
            });
        },
        SET_IS_NEWS_LOADING(state, isLoading) {
            state.isNewsLoading = isLoading;
        },
        SET_IS_FILTERS_VISIBLE(state, isVisible) {
            state.isFiltersVisible = isVisible;
        },
    },
    actions: {
        async fetchNews({ commit }, { statusId = 0, page = 1 } = {}) {
            let url = 'base/articles/';

            if (statusId && page) {
                url += `?status_id=${statusId}&page=${page}`;
            } else {
                url += `?page=${page}`;
            }

            commit('SET_IS_NEWS_LOADING', true);
            try {
                const payload = await this.$axios.$get(url);

                commit('SET_PAYLOAD', payload);
                commit('BUILD_NEWS_BY_STATUS');
            } catch (err) {
                // здесь можно обработать ошибку
                console.error('Ошибка загрузки новостей:', err);
            } finally {
                commit('SET_IS_NEWS_LOADING', false);
            }
        },
        async changePage({ commit }, { query, page }) {
            if (!page) {
                page = 1;
            }

            commit('SET_PAGE', page);

            if (process.server) {
                return;
            }

            if (page !== 1) {
                await this.$router.push({ query: { ...query, page: page } });
                return;
            }

            const newQuery = { ...query };

            if (newQuery.tab === 0) {
                delete newQuery.tab;
            }

            delete newQuery.page;

            await this.$router.push({ query: newQuery });
        },
    },
    // getters: {},
};

export default store;
